import React from "react";
import InputGroup from "@/components/InputGroup";
// import HeaderWeb from '@/components/headerweb'
import request from "@/utils/request";
import sign from "@/utils/sign";
import { sendPhoneCode } from "@/utils/sendPhoneCode";
import { getLocationSearch } from "@/utils/utils";
import { loginApi } from "@/api";
import "./index.scss";

class PhoneVerify extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      iscorrect: true,
      count: 60,
      errorTxt: "验证码错误，请重新输入",
      userToken: "",
    };
    this.getValue = this.getValue.bind(this);
    this.phone = props.match.params.phone;
    this.drivername = props.match.params.drivername;
    this.cityId = props.match.params.cityid;
    this.history = props.history;
    this.timer = null;
    this.shareKey = getLocationSearch().shareKey;
  }
  getValue(value) {
    if (value.length === 6) {
      //登陆或注册接口请求
      request
        .post(
          loginApi,
          {
            mobilePhone: this.phone,
            checkCode: value,
            appKey: "share_h5",
            pushChannelId: "",
            //发生改变
            shareKey: this.shareKey,
            driverName: this.drivername,
            cityId: this.cityId,
          },
          {
            ...sign.sign_share,
          }
        )
        .then((data) => {
          // 登陆 、 注册
          if (
            data.data.errorMsg === "验证码错误" ||
            data.data.errorCode !== 0
          ) {
            this.child.setIsCorrect(false);
            this.setState({
              iscorrect: false,
              errorTxt: "验证码错误",
            });
          } else if (data.data.errorMsg === "SUCCESS") {
            this.setState({
              iscorrect: true,
            });
            let { loginMode } = data.data.data;
            if (loginMode === 1) {
              //赋值token
              this.setState({
                userToken: data.data.data.token,
              });
              //登陆并注册
              this.history.push({
                pathname: `/newuser/${this.phone}/${this.state.userToken}`,
              });
            } else if (loginMode === 0) {
              //赋值token
              this.setState({
                userToken: data.data.data.token,
              });
              this.history.push({
                pathname: `/olduser/${this.phone}/${this.state.userToken}`,
              });
            }
          }
        });
      //路由跳转
      // this.history.push({
      //   pathname: `/newuser/${this.cxname}/${this.phone}`
      // })
    }
  }
  countDown() {
    clearInterval(this.timer);
    let _this = this;
    this.timer = setInterval(() => {
      _this.setState({
        count: this.state.count - 1,
      });
      if (this.state.count <= 0) {
        clearInterval(_this.timer);
        _this.setState({
          iscorrect: false,
        });
      }
      if (this.state.count < 0) {
        clearInterval(_this.timer);
      }
    }, 1000);
  }

  //重新触发倒计时、清空input验证码框、重新发送验证码
  handleAgainCount() {
    this.setState({
      count: 60,
      iscorrect: true,
    });
    this.countDown();
    this.handleClearCode();
    // 调用子组件方法设置子组件的iscorrect
    this.child.setIsCorrect(true);
    //重新发送验证码
    sendPhoneCode(this.phone).then((data) => {
      //做验证码修改 再判断！！！！！！
      // console.log(data);
    });
  }
  componentDidMount() {
    this.countDown();
  }

  //调用子组件方法
  onRef = (ref) => {
    this.child = ref;
  };
  handleClearCode = () => {
    this.child.clearCode();
  };

  //组件销毁
  componentWillUnmount() {
    clearInterval(this.timer);
  }
  render() {
    return (
      <div className="phone-verify__box">
        {/* <HeaderWeb tit="" /> */}
        <div className="phone-verify__show">
          <h2>验证手机</h2>
          <div className="count-down">
            {this.state.count > 0 ? (
              this.state.count + "s"
            ) : (
              <em
                onClick={this.handleAgainCount.bind(this)}
                style={
                  React.colorConfig
                    ? React.colorConfig.regainBtn
                    : { color: "#FFA43C" }
                }
              >
                重新获取
              </em>
            )}
          </div>
          <InputGroup
            getValue={this.getValue}
            length={6}
            type={"line"}
            borderColor={this.color}
            iscorrect={this.state.iscorrect}
            onRef={this.onRef}
          />
          <p className="phone-info">
            {this.state.iscorrect ? (
              <em>验证码已经发送到手机 +86 {this.phone} </em>
            ) : (
              <em style={{ color: "#E40101" }}>{this.state.errorTxt}</em>
            )}
          </p>
        </div>
      </div>
    );
  }
}
export default PhoneVerify;
